// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3AWGd1Zzt5Cda4 {\n  margin-top: 64px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n._3AWGd1Zzt5Cda4 ._3pGTAEcndte7sB {\n  font-size: 20px;\n  text-align: center;\n}\n._3AWGd1Zzt5Cda4 .SIas0ozeMAvy8G {\n  margin-top: 32px;\n  padding: 8px 32px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": "_3AWGd1Zzt5Cda4",
	"message": "_3pGTAEcndte7sB",
	"clearCardFilters": "SIas0ozeMAvy8G"
};
export default ___CSS_LOADER_EXPORT___;
